<template>
  <div class="text-container">
    <section v-for="group in menuGroups" class="menu-group" :key="contentFor(group.title)">
      <h1>{{ contentFor(group.title) }}</h1>
      <div class="text" v-html="contentAsHtml(group.text)" />
    </section>
  </div>
</template>

<script>
  import Slice from 'mixins/slice';

  export default {
    name: 'MenuGroupSlice',
    mixins: [Slice],

    computed: {
      menuGroups () {
        return this.slice.items;
      }
    }

  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/typo'
  @require '~global/helpers'

  .text-container
    max-width: 800px
    margin: 0 auto

  .menu-group p
    position: relative
    padding: .6rem 0
    &:before
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-image: repeating-linear-gradient(
        to right,
        black 0 6px,
        transparent 6px 9px
      )

  .menu-group p:last-of-type
    &:after
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-image: repeating-linear-gradient(
        to right,
        black 0 6px,
        transparent 6px 9px
      )

</style>
